var menu = [];

localStorage.getItem("urole") === "16"
  ? window.location.pathname === "/NCSCDA"
    ? (menu = [
        {
          icon: "dashboard",
          text: "User Dashboard",
          link: "/Dashboard",
          active: false,
        },

        {
          icon: false,
          text: "Gender Wise Category",
          link: "/NCSCDA?data=5",
          active: true,
        },
        {
          icon: false,
          text: "Caste-wise Categorisation",
          link: "/NCSCDA?data=6",
          active: true,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation VH",
          link: "/NCSCDA?data=7",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation OH",
          link: "/NCSCDA?data=9",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation HH",
          link: "/NCSCDA?data=8",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation CL",
          link: "/NCSCDA?data=10",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MR",
          link: "/NCSCDA?data=11",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MD",
          link: "/NCSCDA?data=12",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation Others",
          link: "/NCSCDA?data=13",
          active: false,
        },
        {
          icon: false,
          text: "Trade-wise Categorisation",
          link: "/NCSCDA?data=14",
          active: false,
        },
        {
          icon: false,
          text: "Physical Restoration, Events Organised, Submission, Follow Ups and LR ",
          link: "/NCSCDA?data=15",
          active: false,
        },
        {
          icon: false,
          text: "Camps, Job fairs and Staff Position",
          link: "/NCSCDA?data=16",
          active: false,
        },
        {
          icon: false,
          text: "Preview and Submit",
          link: "/NCSCDA?data=17",
          active: false,
        },
      ])
    : window.location.pathname === "/NCSCDA-Edit"
    ? (menu = [
        {
          icon: "dashboard",
          text: "User Dashboard",
          link: "/Dashboard",
          active: false,
        },

        {
          icon: false,
          text: "Gender Wise Category",
          link: "/NCSCDA-Edit?data=5",
          active: true,
        },
        {
          icon: false,
          text: "Caste-wise Categorisation",
          link: "/NCSCDA-Edit?data=6",
          active: true,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation VH",
          link: "/NCSCDA-Edit?data=7",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation OH",
          link: "/NCSCDA-Edit?data=9",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation HH",
          link: "/NCSCDA-Edit?data=8",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation CL",
          link: "/NCSCDA-Edit?data=10",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MR",
          link: "/NCSCDA-Edit?data=11",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MD",
          link: "/NCSCDA-Edit?data=12",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation Others",
          link: "/NCSCDA-Edit?data=13",
          active: false,
        },
        {
          icon: false,
          text: "Trade-wise Categorisation",
          link: "/NCSCDA-Edit?data=14",
          active: false,
        },
        {
          icon: false,
          text: "Physical Restoration, Events Organised, Submission, Follow Ups and LR ",
          link: "/NCSCDA-Edit?data=15",
          active: false,
        },
        {
          icon: false,
          text: "Camps, Job fairs and Staff Position",
          link: "/NCSCDA-Edit?data=16",
          active: false,
        },
        {
          icon: false,
          text: "Preview and Submit",
          link: "/NCSCDA-Edit?data=17",
          active: false,
        },
      ])
    : window.location.pathname === "/NCSCDA-View"
    ? (menu = [
        {
          icon: "dashboard",
          text: "User Dashboard",
          link: "/Dashboard",
          active: false,
        },

        {
          icon: false,
          text: "Gender Wise Category",
          link: "/NCSCDA-View?data=5",
          active: true,
        },
        {
          icon: false,
          text: "Caste-wise Categorisation",
          link: "/NCSCDA-View?data=6",
          active: true,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation VH",
          link: "/NCSCDA-View?data=7",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation OH",
          link: "/NCSCDA-View?data=9",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation HH",
          link: "/NCSCDA-View?data=8",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation CL",
          link: "/NCSCDA-View?data=10",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MR",
          link: "/NCSCDA-View?data=11",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation MD",
          link: "/NCSCDA-View?data=12",
          active: false,
        },
        {
          icon: false,
          text: "Disability-wise Categorisation Others",
          link: "/NCSCDA-View?data=13",
          active: false,
        },
        {
          icon: false,
          text: "Trade-wise Categorisation",
          link: "/NCSCDA-View?data=14",
          active: false,
        },
        {
          icon: false,
          text: "Physical Restoration, Events Organised, Submission, Follow Ups and LR ",
          link: "/NCSCDA-View?data=15",
          active: false,
        },
        {
          icon: false,
          text: "Camps, Job fairs and Staff Position",
          link: "/NCSCDA-View?data=16",
          active: false,
        },
        {
          icon: false,
          text: "Combine Preview",
          link: "/NCSCDA-View?data=17",
          active: false,
        },
      ])
    : (menu = [
        {
          icon: "dashboard",
          text: "User Dashboard",
          link: "/Dashboard",
          active: false,
        },
      ])
  : window.location.pathname === "/NCSCDA-View"
  ? (menu = [
      {
        icon: "dashboard",
        text: "User Dashboard",
        link: "/Dashboard",
        active: false,
      },

      {
        icon: false,
        text: "Gender Wise Category",
        link: "/NCSCDA-View?data=5",
        active: true,
      },
      {
        icon: false,
        text: "Caste-wise Categorisation",
        link: "/NCSCDA-View?data=6",
        active: true,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation VH",
        link: "/NCSCDA-View?data=7",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation OH",
        link: "/NCSCDA-View?data=9",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation HH",
        link: "/NCSCDA-View?data=8",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation CL",
        link: "/NCSCDA-View?data=10",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation MR",
        link: "/NCSCDA-View?data=11",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation MD",
        link: "/NCSCDA-View?data=12",
        active: false,
      },
      {
        icon: false,
        text: "Disability-wise Categorisation Others",
        link: "/NCSCDA-View?data=13",
        active: false,
      },
      {
        icon: false,
        text: "Trade-wise Categorisation",
        link: "/NCSCDA-View?data=14",
        active: false,
      },
      {
        icon: false,
        text: "Physical Restoration, Events Organised, Submission, Follow Ups and LR ",
        link: "/NCSCDA-View?data=15",
        active: false,
      },
      {
        icon: false,
        text: "Camps, Job fairs and Staff Position",
        link: "/NCSCDA-View?data=16",
        active: false,
      },
      {
        icon: false,
        text: "Combine Preview",
        link: "/NCSCDA-View?data=17",
        active: false,
      },
    ])
  : (menu = [
      {
        icon: "dashboard",
        text: "Admin Dashboard",
        link: "/Admin-Dashboard",
        active: false,
      },
      {
        icon: "grid-box-alt-fill",
        text: "Main Report",
        link: "/Report",
        active: false,
      },
      
       {
        icon: "layers-fill",
        text: "Intake",
        link: "/ReportIntake",
        active: false,
      },
      {
        icon: "sign-eos",
        text: "Evaluation",
        link: "/ReportEvaluation",
        active: false,
      },
      {
        icon: "ni ni-stop-circle",
        text: "Rehabilitation",
        link: "/ReportRehabilitation",
        active: false,
      },
      {
        icon: "cards",
        text: "Rehabilitation-VH",
        link: "/RehabilitationVh",
        active: false,
      },
      {
        icon: "loader",
        text: "Rehabilitation-HH",
        link: "/RehabilitationHH",
        active: false,
      },

      {
        icon: "calendar-alt",
        text: "Rehabilitation-OH",
        link: "/RehabilitatiOH",
        active: false,
      },
      {
        icon: "cpu",
        text: "Rehabilitation-Cl",
        link: "/RehabilitationCl",
        active: false,
      },
      {
        icon: "filter",
        text: "Rehabilitation-MR",
        link: "/RehabilitationMR",
        active: false,
      },
      {
        icon: "activity-round-fill",
        text: "Rehabilitation-MD",
        link: "/RehabilitationMD",
        active: false,
      },
      {
        icon: "speed",
        text: "Rehabilitation-Others",
        link: "/RehabilitationOthers",
        active: false,
      },

      {
        icon: "inbox",
        text: "Job Fairs",
        link: "/ReportJobsikers",
        active: false,
      },
      {
        icon: "map",
        text: "Trainees",
        link: "/ReportTrade",
        active: false,
      },
      {
        icon: "spark-fill",
        text: "Incumbancy Position",
        link: "/ReportIncumbancy",
        active: false,
      },

      /* {
            icon: "template-fill",
            text: "Wage Paid",
            link: "/ReportIntake?data=161",
            active: false,


            },    {
                icon: "laravel",
            text: "Training at Centre",
            link: "/ReportIntake?data=162",
            active: false,


            },    {
                icon: "movie",
            text: "Training Others",
            link: "/ReportIntake?data=163",
            active: false,


            }, 
          {
              icon: "light",
              text: "Self Employment",
              link: "/ReportIntake?data=164",
            active: false,


            }, */
    ]);

export default menu;
